export const navigationMenuLinks = [
    {
        id: 'product',
        text: 'Product',
        links: [
            {
                id: 'product-overview',
                text: 'Overview',
                link: '/overview',
                links: [
                    {
                        id: 'product-overview-features',
                        text: 'Feature Suites',
                        link: '/overview#feature-suites',
                    },
                    {
                        id: 'product-overview-featuresAll',
                        text: 'All Features',
                        link: '/overview#all-features',
                    },
                    // {
                    //     id: 'product-overview-security',
                    //     text: 'Security & Architecture',
                    //     link: '/product#overview-security'
                    // }
                ],
            },
            {
                id: 'product-demo',
                text: 'Demo',
                link: '/demo',
                links: [
                    {
                        id: 'product-demo-sampleStores',
                        text: 'Live Stores',
                        link: '/demo#examples',
                    },
                ],
            },
            {
                id: 'product-services',
                text: 'Services',
                link: '/services',
                links: [
                    {
                        id: 'product-services-setup',
                        text: 'Done-For-You Setup',
                        link: '/services#our-services_services-page',
                    },
                    // {
                    //     id: 'product-services-teamTraining',
                    //     text: 'Team Training (+1 free setup)',
                    //     link: '/services#team-training'
                    // },
                    {
                        id: 'product-services-portfolio',
                        text: 'Portfolio',
                        link: '/services#portfolio',
                    },
                ],
            },
            // {
            //     id: 'product-enterprise',
            //     text: 'Enterprise',
            //     link: '/product#enterprise',
            //     links: [
            //         {
            //             id: 'product-enterprise-performance',
            //             text: 'Performance & Scale',
            //             link: '/product#enterprise-performance'
            //         },
            //         {
            //             id: 'product-enterprise-inventory',
            //             text: 'Real-time Inventory & Operations',
            //             link: '/product#enterprise-inventory'
            //         },
            //         {
            //             id: 'product-enterprise-markets',
            //             text: 'Markets & International',
            //             link: '/product#enterprise-markets'
            //         },
            //         {
            //             id: 'product-enterprise-security',
            //             text: 'Security & Compliance',
            //             link: '/product#enterprise-security'
            //         }
            //     ]
            // }
        ],
    },
    {
        id: 'solutions',
        text: 'Solutions',
        links: [
            // {
            //     id: 'solutions-byIndustry',
            //     text: 'By Industry',
            //     link: '/solutions#by-industry',
            //     links: [
            //         {
            //             id: 'solutions-byIndustry-apparel',
            //             text: 'Apparel & POD',
            //             link: '/solutions#by-industry-apparel'
            //         },
            //         {
            //             id: 'solutions-byIndustry-gifts',
            //             text: 'Gifts & Bundles',
            //             link: '/solutions#by-industry-gifts'
            //         },
            //         {
            //             id: 'solutions-byIndustry-furniture',
            //             text: 'Furniture & Custom Dimensions',
            //             link: '/solutions#by-industry-furniture'
            //         },
            //         {
            //             id: 'solutions-byIndustry-trophies',
            //             text: 'Trophies & Awards',
            //             link: '/solutions#by-industry-trophies'
            //         },
            //         {
            //             id: 'solutions-byIndustry-b2b',
            //             text: 'B2B & Wholesale',
            //             link: '/solutions#by-industry-b2b'
            //         }
            //     ]
            // },
            // {
            //     id: 'solutions-byUseCase',
            //     text: 'By Use Case',
            //     link: '/solutions#by-use-case',
            //     links: [
            //         {
            //             id: 'solutions-byUseCase-sku',
            //             text: 'SKU Control (SKU Constructor)',
            //             link: '/solutions#by-use-case-sku'
            //         },
            //         {
            //             id: 'solutions-byUseCase-international',
            //             text: 'International (Shopify Markets)',
            //             link: '/solutions#by-use-case-international'
            //         }
            //     ]
            // },
            {
                id: 'solutions-learn',
                text: 'Learn & Tools',
                link: 'https://buildateam.zendesk.com/hc/en-us',
                newTab: true,
                links: [
                    // {
                    //     id: 'solutions-learn-presets',
                    //     text: 'Presets Library',
                    //     link: '/learn#presets-library'
                    // },
                    // {
                    //     id: 'solutions-learn-ai',
                    //     text: 'Experienced AI agents', // How ai can be 'experienced'?
                    //     link: '/learn#ai'
                    // },
                    // {
                    //     id: 'solutions-learn-roi',
                    //     text: 'ROI Calculator',
                    //     link: '/learn#roi-calculator'
                    // },
                    {
                        id: 'solutions-learn-training',
                        text: 'Demo Call & Training',
                        link: 'https://calendly.com/d/ctk9-658-xxk/',
                        newTab: true,
                    },
                    // {
                    //     id: 'solutions-learn-guides',
                    //     text: 'Guides',
                    //     link: '/learn#guides'
                    // },
                    {
                        id: 'solutions-learn-guides',
                        text: 'Guides',
                        link: 'https://buildateam.zendesk.com/hc/en-us',
                        newTab: true,
                    },
                ],
            },
        ],
    },
    {
        id: 'pricing',
        text: 'Pricing',
        link: '/pricing',
        links: [
            {
                id: 'pricing-plans',
                text: 'Payment Plans',
                link: '/pricing',
                links: [
                    {
                        id: 'pricing-plans-overview',
                        text: 'Pricing Overview',
                        link: '/pricing#pricing-overview',
                    },
                    // {
                    //     id: 'pricing-plans-features',
                    //     text: 'Features vs Plans',
                    //     link: '/pricing#plans-features'
                    // },
                    {
                        id: 'pricing-plans-addons',
                        text: 'Services Add-ons',
                        link: '/pricing#service-addons',
                    },
                ],
            },
            {
                id: 'pricing-next',
                text: 'Next Steps',
                link: '/#demo-call',
                links: [
                    {
                        id: 'pricing-next-call',
                        text: 'Book a Call',
                        link: '/#demo-call',
                    },
                    {
                        id: 'pricing-next-start',
                        text: 'Start Free',
                        link: 'https://apps.shopify.com/customization-tool',
                        newTab: true,
                    },
                    // {
                    //     id: 'pricing-next-faq',
                    //     text: 'Procurement FAQ',
                    //     link: '/pricing#next-faq'
                    // }
                ],
            },
        ],
    },
    // {
    //     id: 'customers',
    //     text: 'Customers',
    //     link: '/customers',
    //     links: [
    //         {
    //             id: 'customers-caseStudies',
    //             text: 'Case Studies',
    //             link: '/customers#case-studies',
    //             links: [
    //                 // {
    //                 //     id: 'customers-caseStudies-all',
    //                 //     text: 'Case Studies',
    //                 //     link: '/customers#case-studies-all'
    //                 // },
    //                 {
    //                     id: 'customers-caseStudies-videotestimonials',
    //                     text: 'Video Testimonials',
    //                     link: '/customers#case-studies-video-testimonials'
    //                 },
    //                 // {
    //                 //     id: 'customers-caseStudies-metrics',
    //                 //     text: 'Before/After Metrics',
    //                 //     link: '/customers#case-studies-metrics'
    //                 // }
    //             ]
    //         }
    //     ]
    // },
    {
        id: 'ecosystem',
        text: 'Ecosystem',
        links: [
            {
                id: 'ecosystem-integrations',
                text: 'Integrations',
                link: '/integrations',
                links: [
                    {
                        id: 'ecosystem-integrations-shopify',
                        text: 'Shopify',
                        link: '/integrations#shopify-card',
                    },
                    {
                        id: 'ecosystem-integrations-woocommerce',
                        text: 'WooCommerce',
                        link: '/integrations#woocommerce-card',
                    },
                    {
                        id: 'ecosystem-integrations-magento',
                        text: 'Magento 2',
                        link: '/integrations#magento-card',
                    },
                    {
                        id: 'ecosystem-integrations-custom',
                        text: 'Custom Integration',
                        link: '/integrations#js-card',
                    },
                ],
            },
            {
                id: 'ecosystem-partners',
                text: 'Partners',
                link: '/partners',
                links: [
                    {
                        id: 'ecosystem-partners-all',
                        text: 'Our Partners',
                        link: '/partners#all-partners',
                    },
                    {
                        id: 'ecosystem-partners-join',
                        text: 'Become a Partner',
                        link: '/partners#join-partner',
                    },
                ],
            },
            {
                id: 'ecosystem-developers',
                text: 'For Developers',
                link: 'https://buildateam.zendesk.com/hc/en-us/articles/41286003257236-Front-API',
                newTab: true,
                links: [
                    {
                        id: 'ecosystem-developers-api',
                        text: 'API Docs',
                        link: 'https://buildateam.zendesk.com/hc/en-us/articles/41286003257236-Front-API',
                        newTab: true,
                    },
                ],
            },
        ],
    },
    // {
    //     id: 'resources',
    //     text: 'Resources',
    //     link: '/resources',
    //     links: [
    //         {
    //             id: 'resources-resources',
    //             text: 'Resources',
    //             link: '/resources',
    //             links: [
    //                 {
    //                     id: 'resources-resources-help',
    //                     text: 'Help Center',
    //                     link: '/resources#help-center'
    //                 }
    //             ]
    //         }
    //     ]
    // },
    {
        id: 'company',
        text: 'Company',
        links: [
            {
                id: 'company-company',
                text: 'Company',
                link: '/about',
                links: [
                    {
                        id: 'company-company-mission',
                        text: 'Mission',
                        link: '/about#mission',
                    },
                    {
                        id: 'company-company-team',
                        text: 'Our Team',
                        link: '/about#team',
                    },
                ],
            },
            // {
            //     id: 'company-proof',
            //     text: 'Proof',
            //     link: '/proof',
            //     links: [
            //         {
            //             id: 'company-proof-press',
            //             text: 'Press & Awards',
            //             link: '/proof#press'
            //         }
            //     ]
            // },
            // {
            //     id: 'company-contact',
            //     text: 'Contact',
            //     link: '/contact',
            //     links: [
            //         {
            //             id: 'company-contact-sales',
            //             text: 'Contact Sales',
            //             link: '/contact#sales'
            //         },
            //         {
            //             id: 'company-contact-support',
            //             text: 'Support',
            //             link: '/contact#support'
            //         }
            //     ]
            // },
            {
                id: 'company-news',
                text: 'News',
                link: '/news',
                links: [
                    {
                        id: 'company-news-blog',
                        text: 'Blog',
                        link: '/news',
                    },
                ],
            },
        ],
    },
];
